import {useLocalStorage} from '@github-ui/use-safe-storage/local-storage'
import {useRuntimeEnvironment} from '@github-ui/ssr-utils/use-runtime-environment'
import {clsx} from 'clsx'
import {useEffect, useRef, useState} from 'react'

import styles from './OverviewSparkle.module.css'

export const OVERVIEW_SPARKLE_ANIMATION_STORAGE_KEY = 'pull-requests.overview.sparkle-animation-last-played-at'
export const OVERVIEW_SPARKLE_ANIMATION_COOLDOWN_MS = 4 * 24 * 60 * 60 * 1000 // run the animation at most once every 4 days

const isNullableNumber = (value: unknown): value is number | null =>
  value === null || (typeof value === 'number' && Number.isFinite(value))

export function OverviewSparkle() {
  const {isBrowser} = useRuntimeEnvironment()
  const [animate, setAnimate] = useState(false)
  const animationScheduledRef = useRef(false)
  const [lastAnimationAt, setLastAnimationAt] = useLocalStorage<number | null>(
    OVERVIEW_SPARKLE_ANIMATION_STORAGE_KEY,
    null,
    {validator: isNullableNumber},
  )

  useEffect(() => {
    if (!isBrowser) return

    if (!animationScheduledRef.current) {
      const now = Date.now()
      if (lastAnimationAt !== null && now - lastAnimationAt < OVERVIEW_SPARKLE_ANIMATION_COOLDOWN_MS) return

      animationScheduledRef.current = true
      setLastAnimationAt(now, {flush: true})
    }

    const timeout = window.setTimeout(() => setAnimate(true), 0)
    return () => window.clearTimeout(timeout)
  }, [isBrowser, lastAnimationAt, setLastAnimationAt])

  return (
    <span className={clsx(styles.SparkleCharacter, animate && styles.SparkleCharacterAnimated)} aria-hidden="true">
      ✨
    </span>
  )
}
